import tw, { styled } from 'twin.macro';

import LinkGroup from '@/components/LinkGroup/LinkGroup';
import { StyledLink } from '@/components/Link/Link.styles';

export const StyledLinkGroup = styled(LinkGroup)`
  ${tw`my-[4px]`}
  ${tw`flex-col md:flex-row`}

  ${StyledLink} {
    ${tw`self-center`}
  }
`;
